import React from "react";
import { Box, Drawer as MuiDrawer, List } from "@mui/material";
import { useDrawer } from "../../context/drawerProvider";
import { useLocation } from "react-router-dom";
import { useGpuTier } from "../../context/gpuTierProvider";
import ListItem from "./listItem";
import pages from "../pages";

const Drawer = () => {
  const [drawerOpen, setDrawerOpen] = useDrawer();
  const { pathname: activeRoute } = useLocation();
  const closeDrawer = () => setDrawerOpen(false);
  const gpuTier = useGpuTier();

  return (
    <MuiDrawer
      anchor="right"
      open={drawerOpen}
      onClose={closeDrawer}
      PaperProps={{
        sx: {
          ...(gpuTier <= 1
            ? {
                background: "rgba(18, 24, 28, 0.93)",
                borderLeft: "1px solid rgba(40, 40, 40)",
              }
            : {
                background:
                  "linear-gradient(90deg, rgba(21, 27, 31, 0.2), rgba(21, 27, 31, 0.3))",
                backdropFilter: gpuTier <= 1 ? "none" : "blur(8px)",
                borderLeft: "1px solid rgba(255, 255, 255, 0.18)",
              }),
          transform: "translate3d(0, 0, 0)",
        },
      }}
      ModalProps={{
        keepMounted: true,
      }}
    >
      <Box
        sx={{ width: 250 }}
        onClick={closeDrawer}
        component="nav"
        role="navigation"
        aria-label="Navigation Panel"
      >
        <List>
          {pages.map(({ name, nameSec, route, nested }) => (
            <ListItem
              nested={nested}
              primary={name}
              key={name}
              secondary={nameSec}
              route={route}
              isActive={route === activeRoute}
            />
          ))}
        </List>
      </Box>
    </MuiDrawer>
  );
};

export default Drawer;
